import { __assign, __rest } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { forwardRef } from 'react';
import { buttonItemCSS } from './styles';
import BaseItem from './base-item';
var ButtonItem = forwardRef(
// Type needed on props to extract types with extract react types.
function (props, ref) {
    var children = props.children, _a = props.cssFn, cssFn = _a === void 0 ? function (currentStyles) { return currentStyles; } : _a, description = props.description, elemAfter = props.elemAfter, elemBefore = props.elemBefore, _b = props.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = props.isSelected, isSelected = _c === void 0 ? false : _c, onClick = props.onClick, testId = props.testId, overrides = props.overrides, others = __rest(props, ["children", "cssFn", "description", "elemAfter", "elemBefore", "isDisabled", "isSelected", "onClick", "testId", "overrides"]);
    if (!children) {
        return null;
    }
    var Container = isDisabled ? 'span' : 'button';
    return (jsx(Container, __assign({ type: isDisabled ? undefined : 'button', css: cssFn(buttonItemCSS(isDisabled, isSelected), {
            isSelected: isSelected,
            isDisabled: isDisabled,
        }), "data-testid": testId, onClick: isDisabled ? undefined : onClick, ref: ref }, others),
        jsx(BaseItem, { overrides: overrides, elemBefore: elemBefore, elemAfter: elemAfter, description: description }, children)));
});
export default ButtonItem;
//# sourceMappingURL=button-item.js.map